export default __webpack_public_path__ + "static/media/streetcart_mobile.20e6fa59.jpg";